<ng-container *transloco="let t">
  <section class="status-grid pb-3">
    <button class="status-button blue">
      {{upcomingCount}} <i class="bi bi-clock ms-1"></i>
    </button>
    <button class="status-button green">
      {{savedCount}}
      <i class="bi bi-check2 ms-1"></i>
    </button>
    <button class="status-button orange" (click)="openCache()">
      {{this.measurementTimeItemHolders.length ?? 0}} <i class="bi bi-arrow-left-right ms-1"></i>
    </button>
  </section>

  <section class="datetime-block mb-3">
    <div class="col-6 competitor-name">
      <div class="ps-2 d-flex">
         <div>{{competitor?.firstName}} {{competitor?.lastName}}</div>
        @if (competitor?.sex === 1) {
        <div class="badge-holder__badge gender-badge-man mx-2">
        <span class="text-uppercase">
        {{ t("app.common.gender.short.1") }}
        </span>
        </div>
        } @else if (competitor?.sex === 2) {
        <div class="badge-holder__badge gender-badge-women mx-2">
        <span class="text-uppercase">
        {{ t("app.common.gender.short.2") }}
        </span>
        </div>
        }
      </div>
    </div>
    <div class="col-6 datetime-text">
       <div>{{ savedTime | localizedDate:'dd.MM.yyyy'}}</div>
          <div>{{ savedTime | localizedDate:'HH:mm:ss'}}</div>
    </div>
  </section>
  <section class="status-grid pb-3">
    <button class="status-button blue" (click)="onSaveTime(CompetitorStatus.DNF)">
      <i class="bi bi-arrow-left-right me-1"></i>
       {{t("competitor.status.DNF")}}
    </button>
    <button class="status-button blue" (click)="onSaveTime(CompetitorStatus.DSQ)">
      <i class="bi bi-arrow-left-right me-1"></i>
      {{t("competitor.status.DSQ")}}
    </button>
    <button class="status-button blue" (click)="onSaveTime(CompetitorStatus.TLE)">
      <i class="bi bi-arrow-left-right me-1"></i>
      {{t("competitor.status.TLE")}}
    </button>
  </section>
  <div class="time-entry-view pb-3">
    <div class="timer-display">
      {{currentTime}}
    </div>
    <div class="entry-display" (click)="onSaveTime()">
      <i class="bi bi-arrow-left-right icon-overlay"></i>
      <input #typedInput class="entry-input" type="text" [value]="typedValue" readonly/>
    </div>
  </div>

  @if (hasConcurrentRace) {
    <div class="keyboard-mode-toggle d-flex mb-2">
      <button type="button" class="keyboard-mode-btn" [class.active]="keyboardMode === 'numeric'" (click)="setKeyboardMode('numeric')">
        123
     </button>
    <button type="button" class="keyboard-mode-btn" [class.active]="keyboardMode === 'alpha'" (click)="setKeyboardMode('alpha')">
      ABC
    </button>
  </div>
  }

  <div class="keypad-grid" [class.keypad-grid--alpha]="keyboardMode === 'alpha'">
    <button *ngFor="let key of activeKeys" class="keypad-button" [ngClass]="key.class" (click)="onKeyPressed(key.label, key.id)">
      @if (key.id === -1) {
      <i class="bi bi-backspace"></i>
      }
      @else if (key.id === -2) {
      <i class="fas fa-trash-alt"></i>
      }
      @else {
      {{key.label}}
      }
    </button>
  </div>
  <div class="event-info-box mt-3">
    <div class="event-text">
      <app-language-output [hrLabel]="waypoint?.pointNameHr" [enLabel]="waypoint?.pointNameEn" [bsLabel]="waypoint?.pointNameBs"
                           [itLabel]="waypoint?.pointNameIt" [srLabel]="waypoint?.pointNameSr"
                           [siLabel]="waypoint?.pointNameSlo" [languages]="languages"/>
      ::
      <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng" [itLabel]="event?.nameIta"
                           [siLabel]="event?.nameSlo" [bsLabel]="event?.nameBs" [languages]="languages"/>
      <small class="event-date">{{event?.start | localizedDate:'short'}}</small>
    </div>
  </div>
  <div class="my-4 horizontal-separator"></div>
  <section>
    <div class="pb-2">
      <app-rounded-button [label]="t('app.common.back')" [btnClass]="'rounded-button--black-outline'" (onClick)="back()"
                          [fullWidth]="true">
        <i class="bi bi-box-arrow-left pe-2"></i>
      </app-rounded-button>
    </div>
  </section>
</ng-container>
